import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    userId: ''
  },
  getters: {
    userId: (state) => state.userId,
  },
  mutations: {
    setUserId(state, payload) {
      state.userId= payload ?? ''
    },
  },
  actions: {
    setUserId({ commit }, payload) {
      commit('setUserId', payload)
    },
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      key: 'rental_store',
      paths: ['userId']
    })
  ]
})
